import * as Util from 'util';

import { CompSearchExecutionContext } from './comp-search-execution-context';

export class CompSearchContext {
  containerId: number;
  pbaId: number;
  compSearchId: number;
  jurisdictionId: number;
  pliTypeId: number;
  pliAverageTypeId: number;
  rejectionTypeId: number;
  rangeDiscussion: string;
  sourceIds: number[];
  sort = [];
  filters = [];
  limit = '';
  skip = '';
  baseUrl: string;
  pliStatus: number;
  executionContext: CompSearchExecutionContext;
  otherRejection: string;
  isRejected: number;
  isAcceptedAndReviewed: number;

  static new(context) {
    const compSearchContext = new CompSearchContext();
    compSearchContext.containerId = context.containerId;
    compSearchContext.pbaId = context.pbaId;
    compSearchContext.compSearchId = context.compSearchId;
    compSearchContext.jurisdictionId = context.jurisdictionId;
    compSearchContext.pliTypeId = context.pliTypeId;
    compSearchContext.pliAverageTypeId = context.pliAverageTypeId || context.pliAvgTypeId;

    compSearchContext.setBaseUrl();

    return compSearchContext;
  }

  setBaseUrl() {
    this.baseUrl = Util.format(
      `compsearch/%s/jurisdiction/%s/pli/%s/pli-avg/%s`,
      this.compSearchId, this.jurisdictionId, this.pliTypeId, this.pliAverageTypeId
    );
  }

  setRejectionTypeId(rejectionTypeId: number) {
    this.rejectionTypeId = rejectionTypeId;
  }
  setSourceIds(sourceIds: number[]) {
    this.sourceIds = sourceIds;
  }
  addSort(sort) {
    this.sort.push(sort);
  }
  addFilter(filter) {
    this.filters.push(filter);
  }
  setPagination(limit, skip) {
    this.limit = limit;
    this.skip = skip;
  }
  setPliStatus(pliStatus) {
    this.pliStatus = pliStatus;
  }
  setExecutionContext(executionContext: CompSearchExecutionContext) {
    this.executionContext = executionContext;
  }
  getQueryString() {
    return `sort=${this.sort.join(',')}&filters=${this.filters.join(',')}&limit=${this.limit}&skip=${this.skip}`;
  }
  setOtherRejection(otherRejection) {
    if (otherRejection === '') {
      this.otherRejection = null;
    } else {
      this.otherRejection = otherRejection;
    }
  }
}
